/* eslint-disable @typescript-eslint/ban-ts-comment */
import { FC } from "react";

import __ from "web/Layout/Translations";

import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

import { SortOptions, SortOptionsProperty } from "../container";
import classes from "./dropdown.scss";

interface IDropdownProps {
  options: (SortOptions | SortOptionsProperty)[];
  onChange: ({ name, direction }: { name: string; direction?: string }) => void;
  darkMode: boolean;
  id: string;
  isOpen: boolean;
}

const Dropdown: FC<IDropdownProps> = ({
  options,
  onChange,
  darkMode = false,
  id,
  isOpen,
}) => {
  const classNameOption = darkMode ? classes.optionDark : classes.option;
  return (
    <div className={classes.root} id={id} aria-hidden={!isOpen}>
      {options?.map((option) => {
        return (
          <ul
            className={classes.group}
            key={(option.name || option.label) as string}
            role="listbox"
          >
            {isArrayHasItems((option as SortOptionsProperty).direction) ? (
              // @ts-ignore
              option.direction.map((directionItem) => (
                <li key={`${option.name}${directionItem.name}`}>
                  <button
                    key={`${option.name}${directionItem.name}`}
                    className={classNameOption}
                    type="button"
                    data-t2={option.name || option.label}
                    data-t1="dropdown_option_button"
                    tabIndex={isOpen ? 0 : -1}
                    onClick={() => {
                      onChange({
                        name: option.name as string,
                        direction: directionItem.name,
                      });
                    }}
                  >
                    <span
                      className={classes.label}
                      data-t1={`${option.name || option.label}_span`}
                    >
                      {/* @ts-ignore */}
                      {__(option.label)}:
                    </span>{" "}
                    {__(directionItem.label)}
                  </button>
                </li>
              ))
            ) : (
              <li key={(option.name || option.label) as string}>
                <button
                  className={classes.option}
                  type="button"
                  data-t2={option.name || option.label}
                  data-t1="dropdown_option_button"
                  tabIndex={isOpen ? 0 : -1}
                  onClick={() => {
                    onChange({
                      name: option.name as string,
                    });
                  }}
                >
                  <span
                    className={classes.label}
                    data-t1={`${option.name || option.label}_span`}
                  >
                    {/* @ts-ignore */}
                    {__(option.label)}
                    {option.name && ":"}
                  </span>
                </button>
              </li>
            )}
          </ul>
        );
      })}
    </div>
  );
};

export default Dropdown;
